import Insights from "./Insights";

function CreativeInsights() {
  return <Insights type={"CAI"} />;
}

export default CreativeInsights;
